import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	LikePetitionSupporterVideo,
	type LikePetitionSupporterVideoMutation,
	type LikePetitionSupporterVideoMutationVariables,
} from './index.graphql';

export async function likePetitionSupporterVideo({
	videoId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	videoId: string;
	utilityContext: UtilityContext;
}): Promise<LikePetitionSupporterVideoMutation | null | undefined> {
	const { data: likeResult } = await fetch<
		LikePetitionSupporterVideoMutation,
		LikePetitionSupporterVideoMutationVariables
	>({
		query: LikePetitionSupporterVideo,
		variables: { videoId },
		rejectOnError: true,
	});
	return likeResult;
}
